import styleGmap from './map/styles'
const loadGoogleMapsApi = require('load-google-maps-api')
import MarkerClusterer from '@google/markerclustererplus'
require('es6-promise').polyfill();
require('bootstrap-3-typeahead')


let image = '/themes/custom/atolbtob/images/map/icon-atol-map-a.png';
// let imageSelected = '/web/themes/custom/atolbtob/images/map/icon-atol-map-selected.png';
let imageSelected = '/themes/custom/atolbtob/images/map/store_32x32.png';

let markers = {};
let map = null;

$("#search_location").typeahead({
    items: 'all',
    matcher() {
        return true
    },
    source: function(query, process) {
        return $.getJSON('/ouvrir-un-magasin/search/' + query, function(d) {
            // console.log(d)
            process(d.map(item => {
                return {
                    id: item.id,
                    name: item.name + ' (' +item.zipcode+')',
                    ville: item.name,
                    zipcode: item.zipcode,
                    lat: item.lat,
                    lng: item.lng,
                }
            }))
        })
    },
    afterSelect(item) {
        // console.log(item)
        $.getJSON('/ouvrir-un-magasin/?ajax=1&lat=' + item.lat +'&lng='+item.lng, function(d) {
            let html = ''
            d.forEach( (item, i) => {
                html += '<li class="list-group-item" data-id="' + item.id + '">' + item.title + ' <span class="badge">' + item.distance + ' km</span></li>'
            })
            $('#lieuxOpportunites ul').html(html);

            // Datalayer GTM
            // Dans la page ‘Raisons de nous rejoindre’, dans la partie ‘de nombreuses opportunités d’installation’, la ville que l’utilisateur écrit et sélectionne dans la partie texte en-dessous de ‘Localisation souhaitée’
            // OK
            let data = {
                'category': 'opportunités ouverture',
                'action': "localisation souhaitée - écrire",
                'label': item.name,
                'value': 0,
                'event': 'event_ga'
            };
            console.log(data);
            dataLayer.push(data);
            initLieuxEvents(d[0])
        })
    }
});



loadGoogleMapsApi({key: gmapKey}).then(function (googleMaps) {


    map = new googleMaps.Map(document.querySelector('#map'), {
        center: {lat: 47.041655, lng: 2.604786},
        zoom: 6,
        styles: styleGmap
    })


    // var strictBounds = new google.maps.LatLngBounds(
    //     new google.maps.LatLng(51.838138, -8.301130),
    //     new google.maps.LatLng(40.350090, 15.176789),
    // );
    //
    // // Listen for the dragend event
    // google.maps.event.addListener(map, 'dragend', function() {
    //     if (strictBounds.contains(map.getCenter())) return;
    //     map.setCenter(new google.maps.LatLng({lat: 47.041655, lng: 2.604786}));
    // });
    //
    // // Limit the zoom level
    // google.maps.event.addListener(map, 'zoom_changed', function() {
    //     if (map.getZoom() < 5.5) map.setZoom(5.5);
    // });






    let infowindow = new google.maps.InfoWindow();



    locations.forEach(
        location => {
            let marker = new google.maps.Marker({
                position: {lat: location.lat, lng: location.lng},
                map: map,
                icon: image,
                title: location.title
            });
            google.maps.event.addListener(marker, 'click', (function(marker) {
                return function() {
                    $('#edit-location').val(location.title)
                    infowindow.setContent('<div id="content" style="text-align: center; margin-bottom: 10px;">' +
                        '   <div class="firstHeading">'+  location.title +'</div>' +
                        '   <div id="bodyContent">' +
                        '       <p>' +
                        '           Vous souhaitez ouvrir un magasin ici ?' +
                        '       </p>' +
                        '       <a href="/rejoignez-atol?fill-votre-projet=creer-un-magasin&fill-votre-ville='+location.title+'" class="btn btn-primary btn-map-ouvrir-magasin">Ouvrir un magasin</a>' +
                        '   </div>' +
                        '</div>')
                    infowindow.open(map, marker);
                    $(document).on("click", '.btn-map-ouvrir-magasin', function () {
                        let city = $(this).text();
                        let data = {
                            'category': 'opportunités ouverture',
                            'action': "carte géographique - ouvrir magasin - click",
                            'label': location.title,
                            'value': 0,
                            'event': 'event_ga'
                        };
                        console.log(data);
                        dataLayer.push(data);
                    });
                }
            })(marker));
            markers['marker_' + location.id] = marker;
        }
    )

    var markerCluster = new MarkerClusterer(map, markers,
        {imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m', gridSize: 50, maxZoom: 12});


}).catch(function (error) {
    console.error(error)
})

// the smooth zoom function
function smoothZoom (map, max, cnt) {
    if (cnt >= max) {
        return;
    }
    else {
        let z = google.maps.event.addListener(map, 'zoom_changed', function(event){
            google.maps.event.removeListener(z);
            smoothZoom(map, max, cnt + 1);
        });
        setTimeout(function(){map.setZoom(cnt)}, 80); // 80ms is what I found to work well on my system -- it might not work well on all systems
    }
}


function initLieuxEvents(selected) {
    $('#lieuxOpportunites ul > li.list-group-item').off('mouseover').on('mouseover', function() {
        markers['marker_' + $(this).data('id')].setIcon(imageSelected)
    }).off('mouseout').on('mouseout', function() {
        markers['marker_' + $(this).data('id')].setIcon(image)
    }).off('click').on('click', function(e) {

        // let zoom = map.getZoom();
        // if (zoom != 10)
        //     map.setZoom(10);

        $('#edit-location').val(markers['marker_' + $(this).data('id')].title)


        map.panTo(markers['marker_' + $(this).data('id')].position)
        smoothZoom(map, 12, map.getZoom())
        setTimeout(() => {
            google.maps.event.trigger(markers['marker_' + $(this).data('id')], 'click')
        }, 500);


    })

  if (selected){
    map.panTo(markers['marker_' + selected.id].position)
    smoothZoom(map, 12, map.getZoom())
    setTimeout(() => {
      google.maps.event.trigger(markers['marker_' + selected.id], 'click')
    }, 500);

  }

}

initLieuxEvents(null)

//////////////////////////////////////////////////////////////

$(document).ready(function() {
  $("#search_location").keydown(function(event){
    if(event.keyCode == 13) {
      event.preventDefault();
      return false;
    }
  });
});
















//
// if($('#carteop').length > 0) {
//
//     $('#carteop').css({height: 500})
//
//
//     var mapObj = new jvm.Map({
//         container: $('#carteop'),
//         map: 'fr_regions_2016_merc',
//         normalizeFunction: 'polynomial',
//         markerStyle: {
//             initial: {
//                 fill: '#F8E23B',
//                 stroke: '#383f47'
//             }
//         },
//         backgroundColor: '#383f47',
//         markers: [],
//         series: {
//             // markers: [{
//             //     attribute: 'image',
//             //     scale: {
//             //         'mrk': 'marker.png'
//             //     },
//             //     values: [],
//             // }]
//         }
//     });
//
//     $.getJSON('/api/opportunites', function(data){
//
//         let mapMarkers = [];
//         let mapMarkersValues = [];
//         data.forEach(item => {
//             console.log(item)
//             mapMarkers.push({name: item.title, latLng: item.loc.split(':')})
//             mapMarkersValues.push('mrk');
//         })
//         mapObj.addMarkers(mapMarkers, []);
//         mapObj.series.markers[0].setValues(mapMarkersValues);
//         console.log(dataVilles)
// //        {latLng: [41.90, 12.45], name: 'Vatican City'},
//
//     })
//
// }



// WEBPACK FOOTER //
// ./web/themes/custom/atolbtob/js/components/map.js